import { getEnvVariable } from '../common/envHelper';

export const AFITD_NAME = getEnvVariable('AFITD_NAME');
export const AFITD_DOMAIN = getEnvVariable('AFITD_DOMAIN');
export const AFITD_WWW_DOMAIN_URL = getEnvVariable('AFITD_WWW_DOMAIN_URL');
export const AFITD_SHARE_URL = getEnvVariable('AFITD_SHARE_URL');
export const AFITD_JITSI_URL = getEnvVariable('AFITD_JITSI_URL');
export const AFITD_COMPANY_NAME = getEnvVariable('AFITD_COMPANY_NAME');
export const AFITD_COMPANY_INC_NAME = getEnvVariable('AFITD_COMPANY_INC_NAME');

export const IOS_BUNDLE_ID = getEnvVariable('IOS_BUNDLE_ID');
export const ANDROID_PACKAGE_NAME = getEnvVariable('ANDROID_PACKAGE_NAME');
export const DYNAMIC_LINK_URL_SCHEME = getEnvVariable('DYNAMIC_LINK_URL_SCHEME');

export const PATH_ROOT = '/';
export const PATH_LOGIN = '/login';
export const PATH_SIGN_IN = '/sign-up';
export const PATH_FORGOT_PASSWORD = '/forgot-password';
export const PATH_AUTH_HANDLER = '/ah';
export const PATH_EMP_INVITE_HANDLER = '/ei';
export const PATH_JOIN_INTERVIEW = '/join-interview';
export const PATH_JOIN_INTERVIEW_TEST_JOIN_CODE = 'uprRC-rIZC'; // join code
export const PATH_EMP_ACCOUNT_LINKAGE = '/el';
export const PATH_AUTH = '/a';
export const PATH_ACCOUNT_SETUP = '/as';
export const PATH_EMP_MEMBER_SETUP = '/ems';
export const PATH_HOME = '/home';
export const PATH_DASHBOARD = '/dashboard';
export const PATH_JOB_CENTER = '/job-center';
export const PATH_TALENT_CENTER = '/talent-center';
export const PATH_RESOURCE_CENTER = '/resource-center';
export const PATH_BRAND = '/brand';
export const PATH_TALENT = '/talent';
export const PATH_EMP_SEARCH = '/emp-search';
export const PATH_ADVERTISE = '/advertise';
// export const PATH_ADMIN_CONSOLE = '/admin-console';
export const PATH_ADMIN_CONSOLE = '/admin4Ei2R1LkOtuFRvyCC3nl';
export const PATH_ADMIN_UTIL = '/adminLDdKkku3dfgzOORrgnju';
export const PATH_SURVEY = '/survey';
export const SUMMER_INTERN_PROGRAM = '/summer-intern-program';
export const PRE_LAUNCH_PAGE = '/pre-launch';

export const PATH_SUB_PAGE_VERIFICATION_EMAIL_SENT = 'email-sent';

export const PATH_SUB_PAGE_FAQ = 'faq';
export const PATH_SUB_PAGE_JOB_SEEKER = 'job-seeker';
export const PATH_SUB_PAGE_JS = 'js';
export const PATH_SUB_PAGE_EMPLOYERS = 'employers';
export const PATH_SUB_PAGE_EMP = 'e';
export const PATH_SUB_PAGE_TERMS = 'terms';
export const PATH_SUB_PAGE_MESSAGE = 'message';
export const PATH_SUB_PAGE_PRIVACY = 'privacy';
export const PATH_SUB_PAGE_JITSI = 'jitsi';
export const PATH_SUB_PAGE_JOB = 'j';

export const QUERY_PARAM_NAME_MODE = 'm';
export const QUERY_PARAM_NAME_USER_TYPE = 'ut';
export const QUERY_PARAM_NAME_HIDE_USER_TYPE = 'hut';

export const TOP_NAV_MODE_LOGIN = 'login';
export const TOP_NAV_MODE_SIGN_UP = 'sign_up';

export const LOGIN_MODE_LOGIN_JS = 'login_js';
export const LOGIN_MODE_LOGIN_EMP = 'login_emp';
export const SIGN_UP_MODE_JS = 'sign_up_js';
export const SIGN_UP_MODE_EMP = 'sign_up_emp';

export const AUTH_MODE_RESET_PASSWORD = 'resetPassword';
export const AUTH_MODE_RECOVER_EMAIL = 'recoverEmail';
export const AUTH_MODE_VERIFY_EMAIL = 'verifyEmail';

export const AUTH_PROVIDER_ID_GOOGLE = 'google.com';
export const AUTH_PROVIDER_ID_APPLE = 'apple.com';
export const AUTH_PROVIDER_ID_FACEBOOK = 'facebook.com';
export const AUTH_PROVIDER_ID_TWITTER = 'twitter.com';

export const CLOUD_FUNCTION_NAME_GET_ELASTICSEARCH_JWT = 'getElasticSearchJwt';
export const ELASTICSEARCH_API_URL_PREFIX = getEnvVariable('ELASTICSEARCH_API_URL_PREFIX');
export const CLOUD_FUNCTION_NAME_CALL_ELASTICSEARCH = 'callElasticSearch';

export const CLOUD_FUNCTION_NAME_GET_JITSI_JWT = 'getJitsiJwt';

export const CLOUD_FUNCTION_NAME_MODERATE_TEXT = 'moderateText';

export const STRIPE_API_PUBLISHABLE_KEY = getEnvVariable('STRIPE_API_PUBLISHABLE_KEY');

export const COMPOSITE_DOC_ID_DELIMITER = '$';

export const DYNAMIC_LINK_PREFIX = getEnvVariable('DYNAMIC_LINK_PREFIX');

export const STRIPE_FREE_TRIAL_LENGTH = 30;

export const VIDEO_RESUME_MAX_LENGTH = 60; // in seconds

export const TEMP_SWITCH_USER_IDS = {
    dairy_queen_1: 'rTe0TiYWRdRYxFiqCeOiu2r4Yyu1',
    coaching_prospects_2: 'Fb1BPKdxw4NEGIQLxXI1UG7cBks1',
    american_painting_2: 'dSgYLkYEfQOZJO5hHpcnqynTsQh2',
    s4_construction_3: 'yVAvRtBZjUWpzMCYsTlFNC5ZTIw1',
    tesla_3: 'EFoBCgi3nKPPRFNOA1AjwZyFy9l1',
    chicago_bulls: 'INxehQOhlEdFBo9I2rVKtnTrsWB3',
    chipotle: 'hrJZqoTGmKV6ee7ZfxVQIBUMdEV2',
    entero_it_solutions: 'sXkfZ7BicONhAiv75K5svLzn2Th1',
    six_flags_america: 'dKl2nDm3wJS4lHRFZoecSn4YqOp2',
    tom_clancy: 'TdrTkoyI5phNqqYFxTNTNUtU1pQ2',
    john_ramsey: 'mpzjktGTzEaMQlP5O7Ev526hwJs1',
    tina_nickel: 'diZ4yTbjMjQ2qFwz9mY5hdjQbQB2',
    sheri_smith: '5OfAlM3cB8NX7n77VLyDilfsEZB2',
    shelly_knolls: 'm6MGcENzdBgQ1UH4nq34FDkBwEh1',
    michael_jordan: 'Q8ecpNFS0PV8QEigJrjVSfiTdo72',
    horace_grant: 'eUlJ7ZrkbCOmfETM8am9x5lj61Q2',
    scottie_pippen: 'ZBSe00K7fkPlsENqfN2pzet1mcj2',
    dennis_rodman: 'No2HpwP5k1Ogr6aRepU1rvs6fc33',
    steve_kerr: 'PA9G3djHb0b5qcjKURqghShmWKj2',
    dawn_small: 'M2kTr3g0x0ab1SxnCnWnoj5J7rf1',
};
